'use strict'

const STATE_KEY = 'root'

export const loadState = () => {
  try {
    const serializedState = localStorage && localStorage.getItem(STATE_KEY) ? localStorage.getItem(STATE_KEY) : null;
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    if(process.browser) {
      localStorage.setItem(STATE_KEY, serializedState);
    }
  } catch (err) {
    // ignore write errors
    console.error(err);
  }
}

export default {
  loadState,
  saveState
}
